<template>
  <el-card v-loading="loading" shadow="never">
    <slot slot="header"></slot>
    <div
      v-for="(item, index) in datalist"
      :key="index"
      @click="
        $router.push({ path: 'detail', query: { ...params, mode: item.name } })
      "
    >
      <h3>{{ item.name }}</h3>
      <div>
        <el-progress type="dashboard" :percentage="item.ratio" :width="150" />
      </div>
      <div class="info">
        <p>合计{{ item.value }}万元</p>
        <p>记录{{ item.count }}条</p>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      datalist: [],
    };
  },
  props: {
    params: { type: Object },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.trend
        .groupMode(this.params)
        .then((res) => {
          let total = res.reduce((acc, cur) => {
            return acc + cur.value;
          }, 0);
          this.datalist = res.map((row) => {
            this.$set(
              row,
              "ratio",
              parseFloat(((row.value / total) * 100).toFixed(1))
            );
            return row;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-card) {
  &__body {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    > div {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>